import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiStockAvailableLot, ApiStockLot, StockAvailableLotFilter, StockLotFilter } from "./types";

interface StockLotsResponse {
    lots: ApiStockLot[];
}

interface StockAvailableLotsResponse {
    avLots: ApiStockAvailableLot[];
}

/** Транспортный слой OMP — партии СУ/УП. */
export const lotsApi = {
    /**
     * Загружает партии по фильтру (`stock/lots.loadByFilter`).
     * @param params фильтр партий
     * @param config опции HTTP-запроса
     */
    load: async (
        params: {
            flt?: StockLotFilter;
        },
        config?: RequestConfig,
    ): Promise<ApiStockLot[]> => {
        const data = await ompApiClient.postOmega<StockLotsResponse>("stock/lots.loadByFilter", params, config);
        return data.lots;
    },

    /**
     * Загружает доступные партии СУ/УП по фильтру.
     * @param params фильтр доступных партий
     * @param config опции HTTP-запроса
     */
    getAvailableLots: async (
        params: {
            flt?: StockAvailableLotFilter;
        },
        config?: RequestConfig,
    ): Promise<ApiStockAvailableLot[]> => {
        const data = await ompApiClient.postOmega<StockAvailableLotsResponse>("stock/lots.getAvLots", params, config);
        return data.avLots;
    },
} as const;
